import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.bold.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBadge',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    bgColor: {
      type: String,
      default: 'ui-kit-bg-primary'
    },
    /**
       * Добавляет класс font-weight-semi-bold
       * */
    bold: {
      type: Boolean,
      default: false
    },
    /**
       * Значение как у prop rounded для vuetify компонентов
       * */
    rounded: {
      type: [String, Boolean],
      default: '12'
    },
    size: {
      type: Number,
      default: 24
    },
    contentClass: {
      type: String,
      default: 'base-badge'
    }
  },
  emits: ['click'],
  setup: function setup(__props) {
    var props = __props;
    var classes = computed(function () {
      if (props.bold) {
        return ["".concat(props.color, "--text"), 'font-weight-semi-bold'];
      }
      return ["".concat(props.color, "--text")];
    });
    return {
      __sfc: true,
      props: props,
      classes: classes
    };
  }
});